<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-sm-7">
            <a v-if="getRoleId != '33'" @click="openPage('/personalTraining/add')" class="btn-primary mr-5"><i class="fas fa-plus-square mr-5"></i>Add</a>
            <a v-if="getRoleId == 1 && is_show_setting" @click="openPage('/ptReport/ptCommissionSetting/index')" class="btn-secondary mr-5">Commission Setting</a>
            <a v-if="getRoleId == 1 && is_show_setting" @click="openPage('/ptReport/ptCommissionTier/index')" class="btn-secondary mr-5">Commission Tier Setting</a>
          </div>
          <div class="col-sm-5 text-right">
            <div class="search-header">
              <div class="custom-search-container">
                <div class="input-group custom-search">
                  <input type="text" @keyup.enter="enterClicked(searchData)" v-model="searchData" class="form-control" placeholder="Search">
                  <span class="icon-magnifier icon-input-custom"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <b-table @sort-changed="sortingChanged" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage">
          <template v-slot:cell(thumbnail)="data">
<!--          <template slot="thumbnail" slot-scope="data">-->
            <b-btn @click="showModal('personalTraining' + data.item.id)" size="sm" variant="outline-danger"><i class="fas fa-eye mr-5"></i>View</b-btn>
            <b-modal modal-class="modal-custom-image" hide-footer :ref="'personalTraining' + data.item.id" centered title="Personal Training">
              <img class="w-100 img-fix" :src="parseImg(data.item.thumbnail)">
            </b-modal>
          </template>
          <template v-slot:cell(is_facerecognition)="data">
            <template>
              <b-badge v-if="data.item.is_facerecognition == 1" :variant="'success'" >Yes</b-badge>
              <b-badge v-if="data.item.is_facerecognition == 0"  :variant="'info'" >No</b-badge>
            </template>
          </template>
          <template v-slot:cell(status)="data">
<!--          <template slot="status" slot-scope="data">-->
            <b-badge :variant="getBadge(data.item.status)">{{data.item.status}}</b-badge>
          </template>
          <template v-slot:cell(created_at)="data">
<!--          <template slot="status" slot-scope="data">-->
              {{ data.item.created_at }} ({{ formatNewDate(data.item.created_at) }})
          </template>
          <template v-slot:cell(actions)="data">
<!--          <template slot="actions" slot-scope="data">-->
            <b-button v-if="getRoleId != '33'" size="sm" @click="editPersonalTraining('/personalTraining/edit?id=' + data.item.id)" class="btn-table primary mr-1">
              <i class="far fa-edit"></i>
            </b-button>
            <b-button v-if="getRoleId != '33'" size="sm" v-on:click="deletePersonalTraining(data.item.id)" class="btn-table danger">
              <i class="fas fa-times"></i>
            </b-button>
          </template>
        </b-table>
        <app-pagination class="pagination-custom mt-20" :current-page="currentPage"
            :total-pages="totalPage"
            @page-changed="pageOneChanged"
            prev-text="Prev" next-text="Next"/>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { Auth } from '@/api'
import Pagination from '@/views/component/pagination'
import moment from "moment";

export default {
  name: 'personalTraining',
  components: {
    'app-pagination': Pagination
  },
  props: {
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      fields: [
        {
          key: 'name',
          label: 'Name',
          sortable: true
        },
        {
          key: 'nickname',
          label: 'Nickname',
          sortable: true
        },
        {
          key: 'thumbnail',
          label: 'Image',
          sortable: true
        },
        {
          key: 'branch.name',
          label: 'Branch',
          sortable: true
        },
        {
          key: 'status',
          label: 'Status',
          sortable: true
        },
        {
          key: 'is_facerecognition',
          label: 'FaceReq',
          sortable: true
        },
        {
          key: 'created_at',
          label: 'Join Date',
          sortable: true
        },
        {
          key: 'updated_at',
          label: 'Resign Date',
          sortable: true,
          formatter: (value, key, item) => {
            if (item.status == 'inactive') {
              return item.updated_at
            } else {
              return  '-'
            }
          },
        },
        {
          key: 'actions',
          label: 'Actions',
          sortable: false
        }
      ],
      items: [],
      sortType: '',
      sortBy: '',
      searchData: '',
      currentPage: 1,
      paginationLimit: 10,
      totalPage: 0,
      getRoleId: Auth.Session.get().paradigm_role,
      is_show_setting: false
    }
  },
  computed: {
    name () {
      return this.$route.name
    }
  },
  methods: {
    pageOneChanged (pageNum) {
      this.currentPage = pageNum
      this.fetchData()
    },
    sortingChanged (event) {
      // console.log(event.sortDesc)
      // event.sortBy   ==> Field key for sorting by (or null for no sorting)
      // event.sortDesc ==> true if sorting descending, false otherwise
      this.sortBy = event.sortBy
      if (event.sortDesc === false) {
        this.sortType = 'asc'
        // console.log(this.sortType)
      } else {
        this.sortType = 'desc'
        // console.log(this.sortType)
      }
      this.fetchData()
    },
    enterClicked (searchEvent) {
      this.fetchData()
    },
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'danger'
          : status === 'active' ? 'success'
            : status === 'inactive' ? 'danger' : 'primary'
    },
    getRowCount (items) {
      return items.length
    },
    openPage (event) {
      this.$router.push(event)
    },
    editPersonalTraining (event) {
      this.$router.push(event)
    },
    showModal (id) {
      this.$refs[id].show()
    },
    deletePersonalTraining(event) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You can\'t revert your action',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Delete it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
        showLoaderOnConfirm: false
      }).then((result) => {
        if(result.value) {
          this.$swal('Deleted', 'You successfully deleted this file', 'success')
          axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
          axios.delete('fitness/v1/personal_training/'.concat(event)).then(response => {
            // this.$router.go()
            this.fetchData()
          }).catch(error => {
            console.log('error', error)
          })
        } else {
          this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      })
    },
    parseImg (value) {
      return Auth.apiUrl + 'fitness/v1/img/personal_training/' + value
    },
    fetchData() {
      axios.defaults.headers.common['X-Access-Token'] = Auth.Session.get().paradigm_token
      axios.get('fitness/v1/personal_training?page=' + this.currentPage + '&limit=' + this.paginationLimit + '&sorting=' + this.sortBy + '&sorting_type=' + this.sortType + '&keyword=' + this.searchData+ '&user_id=1').then(response => {
        this.items = response.data.data.rows
        this.totalPage = response.data.meta.pageCount
        // console.log('test', response.data.data.rows)
      }).catch(error => {
        console.log('error', error)
      })
    },
    formatNewDate (value) {
            var tgl_aw = moment(value)
            var tgl_ak = moment(new Date())
            var numYears, numMonths, numDays, hasil;

            numYears = tgl_ak.diff(tgl_aw, 'years');
            tgl_aw = tgl_aw.add(numYears, 'years');
            numMonths = tgl_ak.diff(tgl_aw, 'months');
            tgl_aw = tgl_aw.add(numMonths, 'months');
            numDays = tgl_ak.diff(tgl_aw, 'days');


            if (numYears == 0 && numMonths == 0) {
                if (numDays == 0) {
                    hasil = '1 Hari'
                } else {
                    hasil = numDays + ' Hari'
                }
            } else if (numYears == 0 && numMonths != 0) {
                if (numDays == 0) {
                    hasil = numMonths + ' Bulan'
                } else {
                    hasil = numMonths + ' Bulan, ' + numDays + ' Hari'
                }
            } else if (numYears != 0) {
                if (numMonths == 0 && numDays == 0) {
                    hasil = numYears + ' Tahun';
                } else if (numMonths != 0 && numDays == 0) {
                    hasil = numYears + ' Tahun, ' + numMonths + ' Bulan'
                } else if (numMonths == 0 && numDays != 0) {
                    hasil = numYears + ' Tahun, ' + numDays + ' Hari'
                } else if (numMonths != 0 && numDays != 0) {
                    hasil = numYears + ' Tahun, ' + numMonths + ' Bulan, ' + numDays + ' Hari'
                }
            }

            return hasil
    }
  },
  created () {
    this.fetchData()

    if (this.$route.query.setting) {
      this.is_show_setting = true
    }
  }
}
</script>

<style>
</style>
